import React from "react";
import { Coffee, UtensilsCrossed, Cake, Croissant, Dumbbell, Trophy, Building2, PartyPopper } from "lucide-react";

const segments = [
    {
        icon: Coffee,
        title: "Cafés",
        text: "Acrescenta sumos naturais ao menu sem complicar a operação da barra.",
        bg: "bg-brand-orange-soft",
        accent: "text-brand-orange",
    },
    {
        icon: UtensilsCrossed,
        title: "Restaurantes",
        text: "Sumo fresco como acompanhamento premium em qualquer refeição.",
        bg: "bg-brand-green-soft",
        accent: "text-brand-green",
    },
    {
        icon: Cake,
        title: "Pastelarias",
        text: "Vitaminas e smoothies para partilhar vitrine com os doces.",
        bg: "bg-brand-pink",
        accent: "text-[#CFA059]",
    },
    {
        icon: Croissant,
        title: "Padarias",
        text: "Sumo natural da manhã, todos os dias, com a mesma qualidade.",
        bg: "bg-brand-yellow",
        accent: "text-[#8691A0]",
    },
    {
        icon: Dumbbell,
        title: "Ginásios",
        text: "Linhas Protein e Detox para clientes pré e pós-treino.",
        bg: "bg-brand-ink text-white",
        accent: "text-brand-orange",
        inverted: true,
    },
    {
        icon: Trophy,
        title: "Clubes de Desporto",
        text: "Hidratação + nutrição natural para atletas e balneários.",
        bg: "bg-brand-green text-white",
        accent: "text-white",
        inverted: true,
    },
    {
        icon: Building2,
        title: "Hotelaria",
        text: "Pequeno-almoço, room service, bar de piscina. Sempre pronto.",
        bg: "bg-white ring-1 ring-brand-green/15",
        accent: "text-brand-green",
    },
    {
        icon: PartyPopper,
        title: "Eventos & Catering",
        text: "Operação plug-and-play. Serve centenas sem fruta a estragar.",
        bg: "bg-white ring-1 ring-brand-orange/20",
        accent: "text-brand-orange",
    },
];

export const TargetClients = () => {
    return (
        <section
            id="para-quem"
            data-testid="target-clients"
            className="py-20 md:py-28 bg-white relative overflow-hidden"
        >
            <div
                aria-hidden
                className="absolute inset-0 opacity-[0.03] bg-hex-pattern pointer-events-none"
                style={{ backgroundImage: "url('/brand/pattern-1.png')" }}
            />
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-green">
                        Para quem
                    </span>
                    <h2 className="mt-3 font-display font-medium text-4xl md:text-5xl lg:text-6xl text-brand-ink leading-[1.05] tracking-tight">
                        Feito para quem serve.{" "}
                        <span className="text-brand-orange">Todos os dias.</span>
                    </h2>
                    <p className="mt-4 text-lg text-brand-ink-soft">
                        Se tens clientes com sede, temos a solução. Qualquer espaço, qualquer
                        volume, qualquer hora.
                    </p>
                </div>

                <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                    {segments.map((s) => (
                        <article
                            key={s.title}
                            data-testid={`target-${s.title.toLowerCase().replace(/\s/g, "-").replace(/[&]/g, "e")}`}
                            className={`group rounded-2xl p-6 md:p-7 transition-all hover:-translate-y-2 duration-300 ${s.bg} ${s.inverted ? "shadow-pop" : "shadow-soft hover:shadow-pop"}`}
                        >
                            <div
                                className={`h-12 w-12 rounded-2xl flex items-center justify-center ${s.inverted ? "bg-white/15" : "bg-white shadow-soft"}`}
                            >
                                <s.icon className={`h-5 w-5 ${s.accent}`} />
                            </div>
                            <h3
                                className={`mt-5 font-display font-medium text-xl md:text-2xl ${s.inverted ? "" : "text-brand-ink"}`}
                            >
                                {s.title}
                            </h3>
                            <p
                                className={`mt-2 text-sm leading-relaxed ${s.inverted ? "text-white/80" : "text-brand-ink-soft"}`}
                            >
                                {s.text}
                            </p>
                        </article>
                    ))}
                </div>

                <div className="mt-12 flex flex-wrap items-center justify-center gap-3 text-sm text-brand-ink-soft">
                    <span>Não encontras o teu negócio?</span>
                    <a
                        href="#contacto"
                        data-testid="target-custom-cta"
                        className="inline-flex items-center gap-1 font-bold text-brand-green hover:underline"
                    >
                        Fala connosco →
                    </a>
                </div>
            </div>
        </section>
    );
};
